import { ArticlePublicPage, ArticlesIndexPage } from "@/app/lazyRoutes";
import { Redirect, Route, Switch } from "wouter";

/** SPA routes when served on knowledge.claritygroup.com.sg — articles only. */
export default function KnowledgeCentreDomainRouter() {
  return (
    <Switch>
      <Route path="/articles/:slug" component={ArticlePublicPage} />
      <Route path="/articles" component={ArticlesIndexPage} />
      <Route path="/">
        <Redirect to="/articles" />
      </Route>
      <Route>
        <Redirect to="/articles" />
      </Route>
    </Switch>
  );
}
